/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, Component, Input, signal,
} from '@angular/core';
import {
  itemCommentCount, itemLikeCount, itemRoute, itemTitle, itemTypeLabel, shorten,
} from '../../common/community/feed/community-item';
import { toEmojiHtml } from '../../common/community/feed/preview-html';

const COLLAPSED_COUNT = 4;
const EXPANDED_COUNT = 10;

// "What's trending" sidebar card.
@Component({
  selector: 'ut-community-trending',
  templateUrl: './community-trending.component.html',
  styleUrls: ['./community-trending.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommunityTrendingComponent {
  // undefined while loading.
  @Input() feed: any[] | undefined;

  expanded = signal(false);

  readonly skeletons = [1, 2, 3, 4];
  readonly title = (item: any): string => shorten(itemTitle(item) || '', 120);
  readonly titleHtml = (item: any): string => toEmojiHtml(this.title(item));
  readonly typeLabel = itemTypeLabel;
  readonly route = itemRoute;
  readonly likeCount = itemLikeCount;
  readonly commentCount = itemCommentCount;

  get visibleItems(): any[] {
    return this.feed.slice(0, this.expanded() ? EXPANDED_COUNT : COLLAPSED_COUNT);
  }

  rank(index: number): string {
    return String(index + 1).padStart(2, '0');
  }

  get canExpand(): boolean {
    return this.feed.length > COLLAPSED_COUNT;
  }
}
